import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { CheckboxBlockInputStyle, CheckboxBlockLabelStyle, CheckboxBlockStyle } from "./Checkbox.style";
export const CheckboxBlock = ({ id, name, value, label, checked = false, disabled = false, onChange, svg, autoFocus, }) => {
    const [isChecked, setIsChecked] = useState(checked || false);
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);
    const handleInputChange = (event) => {
        if (onChange) {
            onChange(event);
        }
    };
    const iconHifen = (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "2", viewBox: "0 0 10 2", fill: "none", children: _jsx("path", { d: "M0.333252 0.333496V1.66683H9.66659V0.333496H0.333252Z", fill: "white" }) }));
    const iconChecked = (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "9", viewBox: "0 0 12 9", fill: "none", children: _jsx("path", { d: "M4.66649 7.11451L10.7945 0.98584L11.7378 1.92851L4.66649 8.99984L0.423828 4.75717L1.36649 3.81451L4.66649 7.11451Z", fill: "white" }) }));
    return (_jsx(CheckboxBlockStyle, { className: "container", children: _jsx("div", { children: _jsxs(CheckboxBlockLabelStyle, { className: `${disabled ? 'not checkbox-label--disabled' : ''}`, htmlFor: id, style: {
                    alignItems: 'center',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                }, children: [svg === 'hifen' ? iconHifen : svg === 'checked' ? iconChecked : null, _jsx(CheckboxBlockInputStyle, { className: "checkbox", type: "checkbox", checked: isChecked, disabled: disabled, id: id, name: name, value: value, autoFocus: !!autoFocus, onChange: (event) => {
                            handleInputChange(event);
                            setIsChecked(event.target.checked);
                        } }), label] }) }) }));
};
//# sourceMappingURL=Checkbox.js.map